const AccountSettings = () => import(/* webpackChunkName: "vendor-account-settings" */ "@/views/AccountSettings.vue");
import { createRouter, createWebHistory } from "vue-router";
const Dashboard = () => import(/* webpackChunkName: "vendor-dashboard" */ "@/views/Dashboard.vue");
const Invoice = () => import(/* webpackChunkName: "vendor-invoice" */ "@/views/Invoice.vue");
const Message = () => import(/* webpackChunkName: "vendor-message" */ "@/views/Message.vue");
const change_password = () => import(/* webpackChunkName: "vendor-change-password" */ "@/views/change_password.vue");
const VirtualReality = () => import(/* webpackChunkName: "vendor-virtual-reality" */ "@/views/VirtualReality.vue");
const Profile = () => import(/* webpackChunkName: "vendor-profile" */ "@/views/Profile.vue");
const Rtl = () => import(/* webpackChunkName: "vendor-rtl" */ "@/views/Rtl.vue");
const SignIn = () => import(/* webpackChunkName: "vendor-sign-in" */ "@/views/SignIn.vue");
const forgot_password = () => import(/* webpackChunkName: "vendor-forgot-password" */ "@/views/forgot_password.vue");
const SignUp = () => import(/* webpackChunkName: "vendor-sign-up" */ "@/views/SignUp.vue");
const Signature = () => import(/* webpackChunkName: "vendor-signature" */ "@/views/Signature.vue");
const PaymentDetails = () => import(/* webpackChunkName: "vendor-payment-details" */ "@/views/PaymentDetails.vue");
const Enrollment = () => import(/* webpackChunkName: "vendor-enrollment" */ "@/views/Enrollment.vue");
const VendorForms = () => import(/* webpackChunkName: "vendor-vendor-forms" */ "@/views/VendorForms.vue");
const PayrollRates = () => import(/* webpackChunkName: "vendor-payroll-rates" */ "@/views/PayrollRates.vue");

const routes = [
  { path: "/account-settings", name: "Settings", component: AccountSettings },
  {
    path: "/",
    name: "/",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/Invoice",
    name: "Invoice",
    component: Invoice,
  },
  {
    path: "/Message",
    name: "Message",
    component: Message,
  },
  {
    path: "/virtual-reality",
    name: "Virtual Reality",
    component: VirtualReality,
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/rtl-page",
    name: "Rtl",
    component: Rtl,
  },
  {
    path: "/sign-in",
    name: "Sign In",
    component: SignIn,
  },
  {
    path: "/sign-up",
    name: "Sign Up",
    component: SignUp,
  },
  {
    path: "/forgot_password",
    name: "forgot Password",
    component: forgot_password,
  },
  {
    path: "/change_password",
    name: "Change Password",
    component: change_password,
  },
  {
    path: "/signature",
    name: "Signature",
    component: Signature,
  },
  {
    path: "/paymentdetails",
    name: "Payment Dtails",
    component: PaymentDetails,
  },
  {
    path: "/payroll-rates",
    name: "Payroll Rates",
    component: PayrollRates,
  },
  {
    path: "/enrollment",
    name: "Enrollment",
    component: Enrollment,
  },
  {
    path: "/vendor_form",
    name: "Vendor Forms",
    component: VendorForms,
  },
  {
    path: "/payroll-rates",
    name: "Payroll Rates",
    component: PayrollRates,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const tokenExpiration = localStorage.getItem("tokenExpiration");
  const isSignInRoute = to.path === "/sign-in";
  const isforgot_pass = to.path === "/forgot_password";
  const isSignUp = to.path === "/sign-up";

  if (isSignInRoute || isforgot_pass || isSignUp) {
    next();
  } else {
    if (token && tokenExpiration && new Date().getTime() < tokenExpiration) {
      const new_expirationTime = new Date().getTime() + 60 * 60 * 1000;
      localStorage.setItem("tokenExpiration", new_expirationTime);
      next();
    } else {
      next("/sign-in");
    }
  }
});

export default router;
